import { ApiService } from "../apiService";

export class TrackersService extends ApiService {
    constructor() {
        super();

        this.path = '/Trackers';
    }

    getTrackers() {
        return this.get(this.path);
    }

    getTrackersAdminVm() {
        return this.get(this.path + "/trackersvm")
    }

    getTrackerCMD(id) {
        return this.getById(this.path + "/trackercmd", id)
    }

    getResponseParam(id, command) {
        return this.getCommand(this.path, id, command);
    }

    createTracker(newTracker) {
        return this.post(this.path, newTracker);
    }

    updateTracker(updatedTracker) {
        return this.put(this.path, updatedTracker);
    }

    deleteTracker(id) {
        return this.delete(this.path, id);
    }

    deleteFile(id) {
        return this.delete(this.path + "/deleteFile", id);
    }

    uploadTrackerFW(datas) {
        return this.postFile(this.path + "/updateFw", datas);
    }

    uploadCmd(string) {
        return this.SendCommand(this.path + "/updateCmd", string);
    }

    uploadParm(list) {
        return this.sendParam(this.path + "/updateParam", list)
    }

    saveFileFW(file) {
        return this.saveFile(this.path + "/saveFileFW", file);
    }

    getFilesAdm() {
        return this.get(this.path + "/getFiles");
    }

    getAllCommands(deviceId) {
        return this.getById(this.path + "/allCommands", deviceId);
    }

    getAllCommandsParam(deviceId) {
        return this.getById(this.path + "/allCommandsParam", deviceId);
    }

    undoTracker(idTracker) {
        return this.postUndo(this.path + "/undoDeleteOperation", idTracker);
    }

    getCheckLastPacket(id) {
        return this.getById(this.path + "/checkUpdateFw", id);
    }

    cancelUpdateFirmware(deviceId) {
        return this.post(this.path + "/stopDownload/" + deviceId);
    }

    sendPreset(command) {
        return this.SendCommand(this.path + "/sendPreset", command);
    }

    sendBroadcastCommand(broadcastCommand) {
        return this.SendCommand(this.path + "/sendCommandsBroadcast", broadcastCommand);
    }

    getListCommands(devicesId) {
        return this.getByIds(this.path + "/devicesCommands", devicesId);
    }

    getListCommandsParam(devicesId) {
        return this.getByIds(this.path + "/devicesCommandsParam", devicesId);
    }

    deleteCommandById(id) {
        return this.getById(this.path + "/deleteCommand", id);
    }
}